import styled from 'styled-components/macro';

// tslint:disable-next-line:variable-name
export const HighlightEditButtons = styled.div`
  display: flex;
  align-items: center;
  padding: 0 8px;
  overflow: visible;

  button:first-child {
    margin-right: 8px;
  }
`;
